import { registrar } from '@modules/aawz-intelligence-v2/ui-registry'
import registryConsolidator from './ia/registry'
import * as consolidator from './store'

export function consolidatorModule({ store }) {
  // ⚠️ Guarda de REENTRADA (padrão do `modules/crm/index.js:9-11`). Este módulo
  // não tinha nenhuma: `registerModule` chamado duas vezes só sobrescrevia o
  // store em silêncio, então a ausência não doía. Com o `registrar` abaixo ela
  // passa a ser necessária — ele RECUSA chave repetida por desenho (override
  // silencioso entre módulos é bug), e uma segunda chamada faria o boot
  // ESTOURAR em vez de ignorar.
  if (typeof store.hasModule === 'function' && store.hasModule('consolidator')) {
    return
  }

  store.registerModule('consolidator', { ...consolidator, namespaced: true })

  // Os cartões do módulo dentro da conversa (spec-009, [T010]). O MÓDULO se
  // registra e o agregado só consulta — é o que permite o `chat-message.vue`
  // desenhar um cartão de carteira sem importar nada daqui.
  //
  // Aqui, e não numa view: o cartão pode chegar em QUALQUER conversa, e
  // registrar na view faria o mesmo `tool_result` virar cartão numa tela e
  // `fallback-card` na outra.
  registrar(registryConsolidator)
}
